//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectDisplayableObject.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"DraftAngle",0,"Expression",0],[0,"DraftMethod",1,0],[0,"DrawDirection",1,"Direction",0],[1,"EdgesToMoveToDraftedFace",0,"ScCollector",0],[0,"ExtremeFacePointOverridesStationary",1,0],[1,"FacesToDraft",0,"ScCollector",0],[1,"FacesToMoveToDraftedFace",0,"ScCollector",0],[1,"FilletRadius",0,"Expression",0],[0,"MatchScope",1,0],[0,"MatchType",1,0],[0,"MatchingOption",1,1],[1,"PartingObject",0,"SelectDisplayableObject",0],[0,"RepairPartingEdge",1,0],[1,"RepairRadius",0,"Expression",1],[0,"RepairingOption",1,1],[1,"StationaryEdgesAboveParting",0,"ScCollector",0],[1,"StationaryEdgesBelowParting",0,"ScCollector",0],[0,"Tolerance",1,0],[0,"Type",1,0],[1,"UnmatchedEdges",0,"ScCollector",0],[1,"UnmatchedFaces",0,"ScCollector",0],[0,"UseDraftedBodyAsPartingObject",1,0]],[],[]];
SPLM.Features.DraftBodyBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DraftBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DraftBodyBuilder.Method = Object.freeze({
    "Isocline" : "Isocline", "TrueDraft" : "TrueDraft"});

SPLM.Features.DraftBodyBuilder.MatchOption = Object.freeze({
    "None" : "None", "All" : "All", "AllButSelected" : "AllButSelected"});

SPLM.Features.DraftBodyBuilder.MatchingScope = Object.freeze({
    "All" : "All", "AllButSelected" : "AllButSelected"});

SPLM.Features.DraftBodyBuilder.MatchingType = Object.freeze({
    "None" : "None", "ToIsocline" : "ToIsocline", "TangentToFace" : "TangentToFace", "FromEdges" : "FromEdges"});

SPLM.Features.DraftBodyBuilder.RepairOption = Object.freeze({
    "None" : "None", "Blends" : "Blends", "Planes" : "Planes", "Both" : "Both"});

SPLM.Features.DraftBodyBuilder.RepairingPartingEdgeOption = Object.freeze({
    "None" : "None", "WithFillet" : "WithFillet", "WithLineAndFillet" : "WithLineAndFillet"});

SPLM.Features.DraftBodyBuilder.Types = Object.freeze({
    "Edges" : "Edges", "Faces" : "Faces"});

export default SPLM;